// backups.api.ts
import api from "./axios";

export type BackupTier = "daily" | "weekly" | "monthly" | "yearly";
export type BackupStatus = "running" | "success" | "failed";

export interface Backup {
  id: number;
  tier: BackupTier;
  status: BackupStatus;
  filePath: string | null;
  fileSizeBytes: string | null;
  errorMessage: string | null;
  triggeredBy: string;
  startedAt: string;
  finishedAt: string | null;
  prunedAt: string | null;
  createdAt: string;
}

export interface BackupAccessToken {
  id: number;
  label: string;
  createdBy: number;
  lastUsedAt: string | null;
  revokedAt: string | null;
  createdAt: string;
}

export interface CreatedBackupAccessToken extends BackupAccessToken {
  token: string;
}

export function backupDownloadUrl(id: number): string {
  return `/api/backups/${id}/download`;
}

export const backupsApi = {
  list: () => api.get<Backup[]>("/backups"),
  run: () => api.post<Backup>("/backups/run"),
  retry: (id: number) => api.post<Backup>(`/backups/${id}/retry`),
  listTokens: () => api.get<BackupAccessToken[]>("/backups/tokens"),
  createToken: (label: string) => api.post<CreatedBackupAccessToken>("/backups/tokens", { label }),
  revokeToken: (id: number) => api.delete(`/backups/tokens/${id}`),
};
